import {useState} from "react";
import {useNavigate} from "react-router-dom";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";

const currentHour = () => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
};

// Crea la ruta de hoy de la plantilla con el mismo motor que "Calcula ruta" (se recalcula en el servidor).
const CreateRouteOverflow = ({templateId, getBody}) => {
    const [hourStart, setHourStart] = useState(currentHour);
    const [sending, setSending] = useState(false);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertCreated = new SwalAlertChoice({confirmButtonText: "Ver ruta", cancelButtonText: "Cerrar"});
    const disabled = !templateId;

    const onCreate = () => {
        if (!hourStart) {
            Alert.warning("Ruta", "Indique la hora de inicio.");
            return;
        }
        setSending(true);
        axiApi
            .post("/api/distribution/dynamic/overflow/route/create/", {
                ...getBody(),
                id: templateId,
                hour_start: hourStart,
            })
            .then((resp) => {
                if (resp.data.status) {
                    const routeId = resp.data.route_id;
                    AlertCreated.success("Ruta", "Ruta de hoy creada.").then((result) => {
                        if (result.isConfirmed) navigate(`/route-management/route/${routeId}/`);
                    });
                } else {
                    Alert.warning("Ruta", resp.data.message);
                }
            })
            .catch(() => Alert.error("Ruta", "No se ha podido crear la ruta."))
            .finally(() => setSending(false));
    };

    return (
        <div className="border-top pt-3">
            <Form.Label htmlFor="create-route-hour-start">Hora de inicio</Form.Label>
            <Form.Control
                id="create-route-hour-start"
                type="time"
                value={hourStart}
                onChange={(e) => setHourStart(e.target.value)}
            />
            <div className="text-muted small mt-2">Ruta de hoy, sin camión ni conductor.</div>
            {disabled && <div className="text-warning small mt-2">Guarde la plantilla antes de crear la ruta.</div>}
            <button
                type="button"
                className="btn btn-primary mt-2"
                disabled={disabled || sending}
                onClick={onCreate}>
                Instanciar
            </button>
        </div>
    );
};

export default CreateRouteOverflow;
